import React from 'react';
import movements from '../../../../../../../../../../services/movements/index';
import {format} from 'date-fns';
import users from '../../../../../../../../../../services/users';
import PaginationComponent from '../../../../../../components/pagination/index';
import withPaymentModal from '../../../../../../../../hocs/payment-details/index';
const esLocale = require('date-fns/locale/es')

export default withPaymentModal(class Payments extends React.Component {
    state = {
        movements: [],
        users: [],
        page: 0,
        numberOfElements: -1,
        total: 0
    }

    elementsPerPage = 10;

    componentWillMount() {
        movements.find({patient: this.props.patient._id}, (err, payments) => {
            let total = 0;
            payments.forEach(payment => {
                total += payment.pay
            })
            this.setState({total: total})
        })

        movements.count({patient: this.props.patient._id}, (err, count) => {
            movements.find({patient: this.props.patient._id})
                .sort({date: -1})
                .limit(this.elementsPerPage)
                .exec(
                    (err, movements) => {
                        this.setState({movements: movements, numberOfElements: count});
                    }
                )
        })
        users.find({}, (err, users) => {
            this.setState({users: users})
        })
    }

    changePage = (page) => {
        movements.find({patient: this.props.patient._id})
            .sort({date: -1})
            .skip(this.elementsPerPage*page)
            .limit(this.elementsPerPage)
            .exec(
            (err, movements) => {
                this.setState({movements: movements, page: page});
            }
        )
    }

    getStringFromTimestamp = (timestamp) => {
        return format(
            new Date(timestamp),
            "DD/MM/YYYY",
            {locale: esLocale},
        )
    }

    renderRow = (movement, index) => {
        let user = this.state.users.find((user) => user._id == movement.user)

        return (
            <tr onClick={() => this.props.openPaymentDetails(movement, user)} key={index}>
                <td>${movement.pay}</td>
                <td>{this.getStringFromTimestamp(movement.date)}</td>
                <td>{user ? user.userName : "N/A"}</td>
            </tr>
        );
    }

    render() {
        return (
            <React.Fragment>
                <table className="table is-fullwidth is-hoverable">
                    <thead>
                        <tr>
                            <td><b>Total: </b>${this.state.total}</td>
                        </tr>
                        <tr>
                            <th>Cantidad</th>
                            <th>Fecha</th>
                            <th>Recibió</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.movements.map(this.renderRow)}
                    </tbody>
                </table>
                <PaginationComponent numberOfElements={this.state.numberOfElements}
                    elementsPerPage={this.elementsPerPage}
                    changePage={this.changePage}
                    currentPage={this.state.page}
                />
            </React.Fragment>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/scenes/patient-tabs/components/payments/index.js